import { defineMessages } from 'react-intl.macro';

export const messages = defineMessages({
  sendAs: {
    id: 'screens.HubScreen.components.SendAndReceiptWarning.sendAs',
    defaultMessage: 'Send message as {sender}',
  },
});
